<script>
import Eei from './Eei'

export default {
  name: 'EeiAdmin',
  extends: Eei,
  data () {
    return {
      isAdmin: true
    }
  },
  props: {
    
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EeiAdmin.vue